<!-- SaltUI DialogSurface uses an opaque popup, with the shared Salt controls. -->
<template>
  <dialog ref="dialog" class="salt-playlist-manager" aria-label="侧栏歌单显示管理" @cancel.prevent="close" @click="outside" @keydown.esc.stop.prevent="close">
    <header><h2>侧栏歌单</h2><SaltButton style-type="subtle" aria-label="关闭歌单显示管理" @click="close">完成</SaltButton></header>
    <p class="description">选择侧栏显示的歌单，隐藏后仍可在音乐库中使用。</p>
    <div class="playlist-groups">
      <section v-for="group in groups" :key="group.id" class="playlist-group" :aria-label="group.label">
        <div class="group-heading"><div><h3>{{group.label}}</h3><small v-if="group.accountId">账号 {{group.accountId}}<template v-if="group.cached"> · 已保存索引</template></small></div><SaltButton size="small" style-type="plain" @click="setGroup(group)">{{group.cards.every(visible) ? '全部隐藏' : '全部显示'}}</SaltButton></div>
        <div v-for="card in group.cards" :key="card.id" class="playlist-choice" :data-playlist-id="card.id"><label :for="controlId(card)">{{card.name}}<small>{{card.trackCount}} 首</small></label><SaltSwitch :id="controlId(card)" :value="visible(card)" :aria-label="'显示歌单：'+card.name+'（'+group.label+'）'" @input="setVisible([card.id],$event)" /></div>
      </section>
      <p v-if="!groups.length" class="description">创建或同步歌单后，可在这里选择显示。</p>
    </div>
    <p v-if="preferences.error" role="alert">{{preferences.error}}</p>
  </dialog>
</template>
<script>
import {accountVault,accountStates} from '../accounts';
import {sidebarPlaylists,sidebarPlaylistIdentity,setSidebarPlaylistVisible} from '../sidebar-playlists';
import SaltButton from './ui/SaltButton.vue';
import SaltSwitch from './ui/SaltSwitch.vue';
export default {
  name:'SidebarPlaylistManager',components:{SaltButton,SaltSwitch},props:{cards:{type:Array,required:true}},
  data(){return{preferences:sidebarPlaylists,vault:accountVault,accounts:accountStates}},
  computed:{groups(){
    const groups=new Map();
    for(const card of this.cards){
      const {platform,accountId}=sidebarPlaylistIdentity(card),id=JSON.stringify([platform,accountId]);
      if(!groups.has(id)){
        const entry=this.vault.entries.find(item=>item.platform===platform && item.profile.id===accountId);
        const current=this.accounts[platform],profile=entry?.profile || (current?.profile?.id===accountId ? current.profile : null);
        const platformLabel=platform==='qq'?'QQ音乐':platform==='netease'?'网易云音乐':'自建歌单';
        groups.set(id,{id,accountId,label:accountId?platformLabel+' · '+(profile?.nickname || accountId):platformLabel,cached:accountId && !(current?.profile?.id===accountId && current.status==='authenticated'),cards:[]});
      }
      groups.get(id).cards.push(card);
    }
    return [...groups.values()];
  }},
  mounted(){this._opener=document.activeElement;this.$refs.dialog.showModal();},
  beforeDestroy(){this.$refs.dialog.close();const opener=this._opener?.isConnected && this._opener.getClientRects().length ? this._opener : document.getElementById('salt-navigation-trigger');opener?.focus({preventScroll:true});},
  methods:{
    visible(card){return !this.preferences.hidden.includes(card.id);},
    controlId(card){return 'sidebar-playlist-'+encodeURIComponent(card.id);},
    setVisible:setSidebarPlaylistVisible,
    setGroup(group){this.setVisible(group.cards.map(card=>card.id),!group.cards.every(this.visible));},
    close(){this.$emit('close');},
    outside(event){if(event.target!==this.$refs.dialog)return;const r=event.target.getBoundingClientRect();if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom)this.close();},
  },
};
</script>
<style scoped>
.salt-playlist-manager{width:min(520px,calc(100vw - 32px));max-height:calc(100dvh - 40px);padding:24px;border:1px solid var(--salt-stroke);border-radius:30px;background:var(--salt-popup);color:var(--salt-text);box-shadow:0 24px 48px #0000001a,0 4px 16px #00000016;overflow:auto;scrollbar-width:thin;scrollbar-color:var(--salt-subtext) transparent;}
.salt-playlist-manager::backdrop{background:#0005;}
header,.group-heading,.playlist-choice{display:flex;align-items:center;justify-content:space-between;gap:16px;}
h2{font-size:18px;margin:0;}h3{font-size:14px;margin:0;font-weight:600;overflow-wrap:anywhere;}
.description{font-size:13px;line-height:1.6;color:var(--salt-subtext);margin:12px 0 20px;}
.playlist-group+.playlist-group{border-top:1px solid var(--salt-stroke);margin-top:16px;padding-top:16px;}
.group-heading{margin-bottom:8px;}.group-heading>div{min-width:0;}.group-heading>button{flex:none;}
small{display:block;margin-top:3px;font-size:12px;color:var(--salt-subtext);font-weight:400;}
.playlist-choice{min-height:52px;padding:6px 0;font-size:14px;}.playlist-choice label{min-width:0;overflow-wrap:anywhere;cursor:pointer;}.playlist-choice>button{flex:none;}
[role='alert']{font-size:13px;color:var(--salt-error);}
</style>
